// the columns the broadsign gallery tables can be ordered by. only the ones holding a value of
// their own are here, a column filled with a placeholder or with the creation the whole table
// belongs to reads the same on every row and has nothing to order
export enum BroadSignGallerySortColumn {
  NAME = 'name',
  CITY = 'city',
  ACCEPTANCE_STATUS = 'acceptance_status',
  REJECTION_REASON = 'rejection_reason',
}

export enum BroadSignCreationSortColumn {
  USED_BUILDINGS_NOT_SENT_COUNT = 'used_buildings_not_sent_count',
}
